import { Fragment, Ref, forwardRef } from 'react'
import { Switch } from '@headlessui/react'
import { cn } from 'shared/styles'

type Props = {
  isOn: boolean
  onSwitch: (checked: boolean) => void
  disabled?: boolean
  label?: string
  isLabelBefore?: boolean
  labelClassName?: string
}

export const Toggle = forwardRef(
  (
    {
      isOn,
      onSwitch,
      disabled = false,
      label,
      isLabelBefore = false,
      labelClassName,
    }: Props,
    ref: Ref<HTMLButtonElement>,
  ) => {
    const handleSwitchToggle = (isSwitchChecked: boolean) =>
      onSwitch(isSwitchChecked)

    return (
      <Switch.Group>
        <div
          className={cn(
            'inline-flex items-center gap-x-3',
            isLabelBefore && 'flex-row-reverse justify-end',
          )}
        >
          <Switch
            checked={isOn}
            onChange={handleSwitchToggle}
            as={Fragment}
            ref={ref}
            disabled={disabled}
          >
            {({ checked }) => (
              <button
                className={cn(
                  'w-12 flex-none rounded-full p-0.75 transition outline-none select-none disabled:cursor-not-allowed',
                  checked
                    ? 'bg-blue-600 hover:bg-blue-800 focus:bg-blue-800 disabled:bg-blue-200'
                    : 'bg-gray-400 hover:bg-gray-500 focus:bg-gray-500 disabled:bg-gray-200',
                )}
                disabled={disabled}
              >
                <div
                  className={cn(
                    'size-4.5 rounded-full bg-white shadow transition disabled:bg-gray-100',
                    checked ? 'translate-x-6' : 'translate-x-0',
                  )}
                />
              </button>
            )}
          </Switch>
          {label && (
            <Switch.Label
              className={labelClassName || 'flex-none text-sm font-medium'}
            >
              {label}
            </Switch.Label>
          )}
        </div>
      </Switch.Group>
    )
  },
)
